export default "__VITE_ASSET__Dlv2G37z__"